import styled from "styled-components";

export const ConsoleGroupContentPageContainer = styled.div`
  max-width: 900px;
  margin: 5rem auto;

  padding: 0 1rem;
  width: 100%;

  hr {
    margin: 3rem 0;

    border-color: ${({ theme }) => theme.console.sidebar.borderColor};
  }

  .loader {
    width: 20px;
    height: 20px;
  }
`;
